var _rect, _rect2, _rect3, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopHeaderImagePattern2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 85,
    viewBox: "0 0 1600 85",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_97_66446)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 85,
    fill: "#F7F8FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "#0C1356"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_97_66446",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1600,
    height: 1200
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_97_66446)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: -339.062,
    width: 1135,
    height: 851.25,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.875 15.625C141.875 -23.5527 173.635 -55.3125 212.812 -55.3125H283.75V86.5625H212.812C173.635 86.5625 141.875 54.8027 141.875 15.625Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 425.625,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 709.375,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 567.5,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.75,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.5 -55.3125H638.438C677.615 -55.3125 709.375 -23.5527 709.375 15.625C709.375 54.8027 677.615 86.5625 638.438 86.5625H567.5V-55.3125Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.625 -55.3125H567.5C567.5 -16.1348 535.74 15.625 496.562 15.625C457.385 15.625 425.625 -16.1348 425.625 -55.3125Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.625 86.5625H283.75C283.75 47.3848 315.51 15.625 354.688 15.625C393.865 15.625 425.625 47.3848 425.625 86.5625Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 851.25,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 993.125,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.25 86.5625C812.072 86.5625 780.312 54.8027 780.312 15.625C780.312 -23.5527 812.072 -55.3125 851.25 -55.3125V86.5625Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M851.25 86.5625V-55.3125C890.428 -55.3125 922.188 -23.5527 922.188 15.625C922.188 54.8027 890.428 86.5625 851.25 86.5625Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.875 -55.3125H283.75C283.75 -16.1348 251.99 15.625 212.812 15.625C173.635 15.625 141.875 -16.1348 141.875 -55.3125Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M567.5 -55.3125H709.375C709.375 -16.1348 677.615 15.625 638.438 15.625C599.26 15.625 567.5 -16.1348 567.5 -55.3125Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M709.375 -55.3125C748.553 -55.3125 780.312 -23.5527 780.312 15.625C741.135 15.625 709.375 -16.1348 709.375 -55.3125Z",
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M425.625 86.5625C425.625 47.3848 457.385 15.625 496.562 15.625C496.562 54.8027 464.803 86.5625 425.625 86.5625Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 993.125,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1028.59,
    y: -19.8438,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 319.219,
    y: -19.8438,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.4688,
    y: -19.8438,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135,
    y: -339.062,
    width: 1135,
    height: 851.25,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1276.88 15.625C1276.88 -23.5527 1308.63 -55.3125 1347.81 -55.3125H1418.75V86.5625H1347.81C1308.63 86.5625 1276.88 54.8027 1276.88 15.625Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1560.62,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1418.75,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.62 -55.3125H1702.5C1702.5 -16.1348 1670.74 15.625 1631.56 15.625C1592.38 15.625 1560.62 -16.1348 1560.62 -55.3125Z",
    fill: "#BB9F83"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.62 86.5625H1418.75C1418.75 47.3848 1450.51 15.625 1489.69 15.625C1528.87 15.625 1560.62 47.3848 1560.62 86.5625Z",
    fill: "#ADBE9E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1135,
    y: -55.3125,
    width: 141.875,
    height: 141.875,
    rx: 70.9375,
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1276.88 -55.3125H1418.75C1418.75 -16.1348 1386.99 15.625 1347.81 15.625C1308.63 15.625 1276.88 -16.1348 1276.88 -55.3125Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1560.62 86.5625C1560.62 47.3848 1592.38 15.625 1631.56 15.625C1631.56 54.8027 1599.8 86.5625 1560.62 86.5625Z",
    fill: "#0C1356"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1454.22,
    y: -19.8438,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#DAD4CE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1170.47,
    y: -19.8438,
    width: 70.9375,
    height: 70.9375,
    rx: 35.4688,
    fill: "#0C1356"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_97_66446"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 85,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopHeaderImagePattern2);
export default __webpack_public_path__ + "static/media/top-header-image-pattern2.f47670505d5b815500c95446b73bbc7c.svg";
export { ForwardRef as ReactComponent };